import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import * as analyticsActions from 'action/analytics'
import * as reportActions from 'action/report'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Col from 'component/utils/Col'
import AnalyticsFilter from 'component/analytics/FilterForm'
import MostAccessedTableWeb from 'component/analytics/MostAccessedTableWeb'
import Breadcrumb from 'component/Breadcrumb'

class MostAccessedWebContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    accesses: PropTypes.array,
    fetchListMostAccessedMenusWeb: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      filters: {},
    }
  }

  componentDidMount() {
    this.handleFetchAccesses()
  }

  handleFetchAccesses = (filters) => {
    const { auth, fetchListMostAccessedMenusWeb } = this.props

    const params = {
      ...filters,
      inWeb: true,
    }

    this.setState({ filters: params }, () => {
      fetchListMostAccessedMenusWeb(auth, params)
    })
  }

  fetchReports = () => {
    const {
      fetchReports,
      auth: { user },
    } = this.props

    const reportValues = {
      tpReport: 19,
    }

    fetchReports(user.dsToken, reportValues, this.state.filters)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { link: '/analytics', title: translate('analytics.title') },
      { title: translate('analytics.title.most-accessed-reports') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const { translate, accesses } = this.props

    return (
      <section>
        <ContentHeader>{translate('analytics.title')}</ContentHeader>

        <section className='analytics-page'>
          {this.renderBreadcrumb()}

          <div className='margin-left margin-right'>
            <Col lg={3} md={12} sm={12} xs={12} className='padding-left-double'>
              <AnalyticsFilter
                translate={translate}
                handleFilters={this.handleFetchAccesses}
              />
            </Col>

            <Col
              lg={9}
              md={12}
              sm={12}
              xs={12}
              className='padding-left-double margin-bottom-double'
            >
              <div className='container-fluid'>
                {/* Possible errors in here */}
              </div>

              <MostAccessedTableWeb
                translate={translate}
                accesses={accesses}
                fetchReports={this.fetchReports}
              />
            </Col>
          </div>
        </section>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({ analyticsReducer }) => ({
  accesses: analyticsReducer.listWeb.record,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...analyticsActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
const MostAccessedWebTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(MostAccessedWebContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MostAccessedWebTranslated)

/*
 * Exports as component
 */
export { MostAccessedWebTranslated as MostAccessedWeb }
export { MostAccessedWebContainer }
